import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/site";
import CategoryDropdown from "./CategoryDropdown";

const heroImage =
  "https://readdy.ai/api/search-image?query=A%20stylish%20editorial%20flat%20lay%20of%20assorted%20fashion%20items%20including%20a%20clean%20white%20sneaker%2C%20a%20folded%20sage%20green%20hoodie%2C%20a%20coral%20t-shirt%2C%20a%20tan%20tote%20bag%20and%20a%20woven%20hat%20arranged%20neatly%20on%20a%20soft%20warm%20sand%20background%20with%20soft%20diffused%20natural%20daylight%20and%20gentle%20shadows%2C%20fresh%20botanical%20stems%20accenting%20the%20corners%2C%20clean%20minimal%20e-commerce%20product%20photography%2C%20premium%20editorial%20style%2C%20high%20detail%2C%20airy%20fresh%20harmonious%20composition&width=1200&height=900&seq=hero-basetao-02&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
            <i className="ri-sparkling-2-line"></i>
            {t("hero.trust")}
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t("hero.title")}
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {t("hero.subtitle")}
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer transition-colors"
            >
              {t("cta.basetaoSpreadsheet")}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 cursor-pointer transition-colors"
            >
              {t("cta.buyNow")}
              <i className="ri-shopping-bag-3-line"></i>
            </a>
          </div>

          <div className="mt-8 max-w-md">
            <label className="mb-2 block text-sm font-medium text-foreground-700">
              {t("hero.dropdownLabel")}
            </label>
            <CategoryDropdown />
          </div>
        </div>

        <div className="relative hidden lg:block">
          <div className="relative h-[460px] w-full overflow-hidden rounded-2xl">
            <img
              src={heroImage}
              alt="Basetao Spreadsheet product research"
              title="Basetao Spreadsheet product research guide"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="absolute -left-6 top-8 rounded-xl border border-background-200 bg-background-50/95 px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className="ri-footprint-line"></i>
              </span>
              <span className="text-sm font-semibold text-foreground-900">
                {t("categories.shoes")}
              </span>
            </div>
          </div>

          <div className="absolute -right-4 bottom-10 rounded-xl border border-background-200 bg-background-50/95 px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-truck-line"></i>
              </span>
              <span className="text-sm font-semibold text-foreground-900">
                {t("nav.shipping")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}